import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-1 text-sm text-foreground-600">
      <Link to="/" className="hover:text-primary-500 transition-colors whitespace-nowrap">
        <i className="ri-home-4-line"></i>
        <span className="sr-only">首页</span>
      </Link>
      {items.map((item, index) => (
        <span key={index} className="flex items-center gap-1">
          <i className="ri-arrow-right-s-line text-xs"></i>
          {item.href ? (
            <Link to={item.href} className="hover:text-primary-500 transition-colors whitespace-nowrap">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-900 font-medium whitespace-nowrap">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}